import { __assign, __rest } from "tslib";
import React from 'react';
import { getDeviationUrl, getDeviationResourceType, } from '../../../../../_helpers';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useOverlayContext } from '../../../../../hooks/useOverlayContext';
import OverlayCommentControl from '../../../../../Helper/OverlayCommentControl';
var CommentControl = function (_a) {
    var deviation = _a.deviation, hasCommentedOn = _a.hasCommentedOn, props = __rest(_a, ["deviation", "hasCommentedOn"]);
    var showStats = useOverlayContext(deviation).showStats;
    return (React.createElement(OverlayCommentControl, __assign({}, props, { showStats: showStats, href: "".concat(getDeviationUrl(deviation), "#comments"), stat: deviation.stats && deviation.stats.comments, hasCommentedOn: hasCommentedOn, biData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: getDeviationResourceType(deviation),
            creatorid: deviation.author ? deviation.author.useridUuid : undefined,
            itemid: deviation.deviationId,
        } })));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map